<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-2">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 2 of 5</div>
        <h3 class="my-4 general-title">Who are you?</h3>
        <div class="question-container my-9 d-flex">
          <button class="btn btn-outline-primary questionnaire-prev" type="button" value="Previous question"
            v-on:click="$emit('go-back')">
            Previous question
          </button>
          <input class="center" type="text" name="name" placeholder="FIRST NAME *" v-model="inputName" />
          <input class="center" type="text" name="surname" placeholder="LAST NAME *" v-model="inputSurame" />
          <input class="center" type="email" name="email" placeholder="EMAIL ADDRESS *" v-model="inputEmail" />
          <button class="btn btn-outline-primary questionnaire-next" type="button" value="Next question"
            v-on:click="localGoNext">
            Next question
          </button>
        </div>
        <div class="row">
          <label for="">* These are required fields</label>
        </div>
      </div>
      <a v-on:click="$emit('skip-questionnaire')" class="skip-button small-text uppercase" href="#">skip questionnaire</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "questionnare-question-2",
  data() {
    return {
    };
  },
  props: ['questionAnswers'],
  methods: {
    localGoNext: function () {
      if (this.canGoNext()) {
        this.$emit('go-next');
      }
    },
    canGoNext: function () {
      let err = false;
      let firstFocus = false;
      let requiredField = ['name', 'surname', 'email'];
      
      let firstName = window.localStorage.getItem('customerName');
      if(firstName !== null) {
        this.inputName = firstName;
      }
      
      let surname = window.localStorage.getItem('customerSurname');
      if (surname !== null) {
        this.inputSurame = surname;
      }
      
      let email = window.localStorage.getItem('customerEmail');
      if (email !== null) {
        this.inputEmail = email;
      }
      
      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];        
        let k = this.questionAnswers[fieldName];
        
        if (typeof k == "undefined" || k == "") {
          if (!firstFocus && document.querySelector("[name=" + fieldName + "]") != null) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }

        if (fieldName == 'email' && !this.validEmail(this.questionAnswers[fieldName])) {
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  computed: {
    inputName: {
      get() {
        let firstName = window.localStorage.getItem('customerName');
        if (firstName !== null) {
          return firstName;
        }

        return this.questionAnswers.name;
      },
      set(answer) {
        window.localStorage.setItem('customerName', answer);
        this.$emit('set-answer', answer, 'name');
      }
    },
    inputSurame: {
      get() {
        let surname = window.localStorage.getItem('customerSurname');
        if (surname !== null) {
          return surname;
        }
        return this.questionAnswers.surname;
      },
      set(answer) {
        window.localStorage.setItem('customerSurname', answer);
        this.$emit('set-answer', answer, 'surname');
      }
    },
    inputEmail: {
      get() {
        let email = window.localStorage.getItem('customerEmail');
        if (email !== null) {
          return email;
        }
        return this.questionAnswers.email;
      },
      set(answer) {
        window.localStorage.setItem('customerEmail', answer);
        this.$emit('set-answer', answer, 'email');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.questionnare-question-2 {
  input[type=text] {
    width: 33%;
  }

  input[type=email] {
    width: 33%;
    border: none;
    border-bottom: 1px solid black;
    outline: none;
    margin-right: 15px;
  }
}

.questionnaire-next,
.questionnaire-prev {
  width: 300px !important;
  padding: 0;
}
</style>